import React from "react";
import "./dashboard.css"
import { useSelector } from "react-redux"
import ProducerDashBoard from "./BeatMaker/ProducerDashboard";
import FollowerDashBoard from "./Follower/FollowerDashboard";


export default function DashBoard(){
    const user = useSelector(
        store => store.user
    )
    return(
        <React.Fragment>
                    
            {
                user.role === "BEATMAKER" ? <ProducerDashBoard/> : <FollowerDashBoard/>
            }

            <div className="theme-btn"><i class="fa-solid fa-moon"></i></div>

        </React.Fragment>
    )
}